import React from "react";
import SanitizedGrid from "components/SanitizedGrid";
import { ShowProps, Title } from "react-admin";
import { Card, CardContent, Grid, Typography } from "@material-ui/core";
import InvoiceTable from "./components/InvoiceTable";
import { GetParam } from "utils/tools";
import { Helmet } from "react-helmet";
import CreateAdhocInvoiceByCsvButton from "../unapprovedInvoices/components/CreateAdhocInvoiceByCsvButton";

const CommercialDocumentList = (props: ShowProps) => {
  const params = GetParam();

  return (
    <>
      <Title title="Invoices" />
      <Card>
        <CardContent>
          <SanitizedGrid container spacing={2}>
            {params.get("status") === "Unposted" ? (
              <>
                <Grid item xs={6}>
                  <Typography variant="h6">Unapproved Invoice</Typography>
                </Grid>

                <Grid item xs={6}>
                  <CreateAdhocInvoiceByCsvButton />
                </Grid>
              </>
            ) : (
              <>
                <Helmet>
                  <title>Invoices</title>
                </Helmet>
                <Grid item xs={8}>
                  <Typography variant="h6">Finance Information</Typography>
                </Grid>
              </>
            )}

            <Grid item xs={12}>
              <InvoiceTable status={params.get("status")} />
            </Grid>
          </SanitizedGrid>
        </CardContent>
      </Card>
    </>
  );
};

export default CommercialDocumentList;
